import Vue from 'vue';
import gsap from 'gsap';

Vue.component('home-intro', {
    data() {
        return {};
    },

    mounted() {
        this.initHoverEffect();
    },

    methods: {
        initHoverEffect() {
            const text = document.querySelector('.intro__text u');
            const image = document.querySelector(
                '.intro-section__image-wrapper'
            );

            const { color } = window.getComputedStyle(text);

            text.addEventListener('mouseover', () => {
                gsap.to(image, { autoAlpha: 1, display: 'inline-block' });
                gsap.to(text, { zIndex: 2 });
                gsap.to(text, { color: 'white' });
            });

            text.addEventListener('mouseleave', () => {
                gsap.to(image, { autoAlpha: 0, display: 'none' });
                gsap.to(text, { color: color });
            });
        },
    },
});
